import { render, staticRenderFns } from "./OtherElement.vue?vue&type=template&id=1b9348ec"
import script from "./OtherElement.vue?vue&type=script&lang=js"
export * from "./OtherElement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports